import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';

if (dbh_helper.getUrlArea() == "profil") {
    $(document).ready(function () {
        let id = dbh_helper.getUrlParameter("id");
        initImageUpload();

        BindBuchungPositionPopupFunctions();

        dbh_helper.OnSetDefaultFormValues = () => {
            BindBuchungPositionPopupFunctions();
        };

        $("#AdressImageUpload").on("change", function () {
            if (readURL(this)) {
                $(".profile-image-preview").addClass("active");
            }
        })

        $("#addBuchung").on("click", function () {
            return new dbh_ajax().sendGetRequest({
                actionName: "NewSachkostenBuchungPopup",
                controllerName: "Profil",
                parameter: [],
                callbackSuccess: (ajaxResult: any) => {
                    $("#abrechnung-placeholder").html(ajaxResult.responseText);
                    $("#PositionErstellenViewComponentPopup").show();
                },
                callbackError: (ajaxResult: object) => {

                }
            });
        })

        $("#typescriptSachkostenProxy").on("click", function (event, actionName, controllerName, parameter, htmlId, doOnSuccess) {
            return new dbh_ajax().sendGetRequest({
                actionName: actionName,
                controllerName: controllerName,
                parameter: parameter,
                callbackSuccess: (ajaxResult: any) => {
                    $(`${htmlId}`).html(ajaxResult.responseText);
                    doOnSuccess();
                },
                callbackError: (ajaxResult: object) => {

                }
            });
        })
        $(document).on('click', '#sachkostenPositionSubmitBtn', function () {
            let dbhCustomValidation = new dbh_custom_validation();
            if (dbhCustomValidation.validateForm("#addSachkostenForm")) {
                $("#addSachkostenSubmit").trigger("click");
            }
        })

        $(document).on('click', '#OffeneSachkostenTabelleMitSuche .tableDeleteButton', function () {
            let rowId = $(this).closest("tr").data('rowid');
            if (rowId == undefined || rowId == '') {
                rowId = $(this).closest(".dbhSuchergebnisKachel").data('rowid');
            }
            dbh_helper.SendGetRequest("GetDeleteConfirmationBuchungPopup", "Profil", [["id", rowId]], "#abrechnung-placeholder", () => {
                $('#BuchungDeletePopupViewComponent').show();
            })
        });

        $(document).on('click', '#OffeneSachkostenTabelleMitSuche td', function () {
            if ($(this).find('.tableDeleteElement').length === 0) {
                let rowId = $(this).closest("tr").data('rowid');
              
                dbh_helper.SendGetRequest("GetEditBuchungenPopup", "Profil", [["id", rowId]], "#abrechnung-placeholder", () => {
                    $('#PositionErstellenViewComponentPopup').show();
                })
            }
        });
        $(document).on('click', '#OffeneSachkostenTabelleMitSuche .dbhSuchergebnisKachel', function () {
            let rowId = $(this).closest(".dbhSuchergebnisKachel").data('rowid');
            dbh_helper.SendGetRequest("GetEditBuchungenPopup", "Profil", [["id", rowId]], "#abrechnung-placeholder", () => {
                $('#PositionErstellenViewComponentPopup').show();
            })
        });

        $(document).on('click', '#sachkostenEinreichenBtn', function () {
            dbh_helper.SendGetRequest("ShowAbrechnunConfirmPopup", "Profil", null, "#abrechnung-placeholder", () => {
                $('#AbrechnungenConfirmViewComponentPopup').show();
            })
        });

        $(document).on('click', '#AbgerechneteSachkostenTabelleMitSuche td', function () {
            if ($(this).find('.dbhCustomTableBtn').length === 0) {
                const rowId = $(this).closest("tr").data('rowid');
                dbh_helper.SendGetRequest("GetAbrechnungPopup", "Profil", [["id", rowId]], "#abrechnung-placeholder", () => {
                    $('#AbrechnungsSachkostenPopupViewComponent').show();
                })
            }
        });
    });
}

const BindBuchungPositionPopupFunctions = () => {
    addBelegInput();

    $(".dbhUploadedBelegDelete").off("click");
    $(".dbhUploadedBelegDelete").on("click", function () {
        $(this).closest(".pnlUploads.done").remove();

        const hdnSachkostenbelegIds = $('.hdnSachkostenbelegId');

        /*Damit beim submit an den Server alle Keys der bereits upgeloadeten Bilder mitgesendet werden,
         muss die Indizierung bei 0 beginnen und fortlaufend sein. Wird z.B. das Element mit dem Index 0 entfernt, 
         werden alle folgenden Elemente nicht mehr mitgesendet.*/
        for (let i = 0; i < hdnSachkostenbelegIds.length; i++) {
            $(hdnSachkostenbelegIds[i]).attr("name", `Belege[${i}].PK_Sachkostenbelege`);
        }
    });

}

const addBelegInput = () => {
    $(".dbhFileUploadPanel.newest input[type=file]").off("change");
    $(".dbhFileUploadPanel.newest input[type=file]").on("change", function () {
        if ($(this).val().toString().length > 0) {
            const $this = $(this);
            $this.off("change");
            const parent = $this.closest(".newest");

            const index = $('.dbhFileUploadPanel').length;

            /* add new Add-Element START */
            const div = $('<div class="dbhInput pnlUploads dbhFileUploadPanel newest"></div>')
            const label = $("<label></label>");
            const span = $('<span>Neuer Beleg</span>');
            const input = $(`<input type="file" id="File_${index}" name="Files[${index}]" class="" value="" autocomplete="off"/>`);
            const svg = $('<svg><use xlink:href="/Wohngruppen/Styles/Images/sprite-icons_optimised.svg#btnPlus"></use></svg>');

            div.append(label);
            label.append(input);
            label.append(span);
            label.append(svg);

            div.insertAfter($('.dbhFileUploadPanel').last());
            addBelegInput();
            /* add new Add-Element END */

            /*replace old Add-Element START*/
            const $pnlUploadedBeleg = $(' <div class="dbhInput pnlUploadedBeleg"></div>');
            const $dbhInput = $('<div class="dbhInput pnlUploadedBelegWrapper"></div>');
            const $dbhUploadedBelegInfo = $('<div class="dbhUploadedBelegInfo"></div>');
            const $dbhUploadedBelegDelete = $('<div class="dbhUploadedBelegDelete"></div>');
            const $delSvg = $('<svg><use xlink:href="/Wohngruppen/Styles/Images/sprite-icons_optimised.svg#btnLoeschen"></use></svg>');

            /*Reihenfolge wichtig, damit Bild im Browser auch angezeigt wird*/
            $pnlUploadedBeleg.append($dbhInput);
            $dbhInput.append($dbhUploadedBelegInfo);
            $dbhInput.append($dbhUploadedBelegDelete);
            $dbhUploadedBelegInfo.append(`<span>${$this.val().toString().split('\\').pop()}</span>`);
            $dbhUploadedBelegDelete.append($delSvg);

            //$pnlUploadedBeleg.insertBefore($('.dbhFileUploadPanel').last());
            parent.find('label').css("display", "none");
            parent.append($pnlUploadedBeleg);
            parent.removeClass("newest").addClass("done");

            $dbhUploadedBelegDelete.on("click", function () {
                $(this).closest(".pnlUploads.done").remove();
            });
            /*replace old Add-Element END*/
        }
    });
}

const initImageUpload = () => {
    $("#uploadNewImageBtn").on("click", () => {
        $("#AdressImageUpload").trigger("click");
    });
}

function readURL(input): boolean {
    if (input.files && input.files[0]) {
        const extension = input.files[0].name.split('.').pop();
        const allowedExtension = [".png", ".jpg", ".jpeg", ".gif"];

        if (allowedExtension.indexOf(`.${extension}`) !== -1) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#profilPrevievImage').attr('src', e.target.result.toString());
            };

            reader.readAsDataURL(input.files[0]);
            return true;
        }
        else {
            input.files = null;
        }
    }
    return false;
}